import { render, staticRenderFns } from "./tags_list.vue.js?vue&type=template&id=731cd9c4!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tags_list.vue?vue&type=template&id=731cd9c4"
import script from "./tags_list.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tags_list.vue?vue&type=script&lang=js"
export * from "./tags_list.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tags_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports